import React, { Component } from 'react';

class Photo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            foto:props.foto
        };
    }
    async componentDidMount() {
        //AT THE RENDERING SEARCH
        //console.log("foto",this.state.foto)

    }

    render() {
        return (
            <section className="room-section room-list-style pt-0 pb-0">
                <div className="room-list-loop">
                    <div className="room-box mb-00">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-12 col-md-12">
                                <div className="room-img-wrap-details">
                                    <img
                                        className="room-img-deteils"
                                        src={this.state.foto}
                                        alt=""
                                        loading="eager"
                                        decoding="async"
                                        onLoad={e => e.currentTarget.classList.add('is-loaded')}
                                        onError={e => { e.currentTarget.src = process.env.PUBLIC_URL + '/assets/img/image-utility/room-details-image-empty.jpg'; e.currentTarget.classList.add('is-loaded'); }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Photo;